import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, of, throwError, tap } from 'rxjs';
import { AppConfigService } from './base/app-config.service';

@Injectable({
  providedIn: 'root'
})
export class AIRService {
  apiBaseUrl = `${AppConfigService.settings.apiUrl}`;
  tagNumber: string = '';


  constructor(private http: HttpClient) {
  }

  /**
   * Gets the current facility ID from localStorage or returns default 'ES'
   */
  getCurrentFacilityId(): string {
    return localStorage.getItem('current_facility_id') || 'ES';
  }

  getAIRData(): Observable<any> {
    const facilityId = this.getCurrentFacilityId();
    return this.http.get(`${this.apiBaseUrl}Air/GetAirCompliance?facilityId=${facilityId}`).pipe(
      catchError(error => {
        return of([]);
      })
    );
  }

  getAirComplianceDetails(tagNumber: string): Observable<any> {
    const facilityId = this.getCurrentFacilityId();
    this.tagNumber = tagNumber;

    if (!tagNumber) {
      return throwError(() => new Error('Tag number is required'));
    }

    // Use { observe: 'response' } to get the full HTTP response including headers
    return this.http.get(
      `${this.apiBaseUrl}Air/GetAirComplianceDetails?tagNumber=${encodeURIComponent(tagNumber)}&facilityId=${facilityId}`,
      { observe: 'response' }
    ).pipe(
      tap(response => {
      }),
      // Map the response back to just the body to maintain compatibility with existing code
      catchError(error => {
        return of([]);
      })
    );
  }

  getDataBasedONDropdownList(divisionName: any, status: string, facilityId: string = '', cal: string = 'tbrr'): Observable<any> {
    const currentFacilityId = facilityId || this.getCurrentFacilityId();
    const encodedDivisionName = encodeURIComponent(divisionName);
    const encodedStatus = encodeURIComponent(status);
    const url = `${this.apiBaseUrl}Air/installed-or-removed-data?divisionName=${encodedDivisionName}&facilityId=${currentFacilityId}&status=${encodedStatus}&email=${localStorage.getItem('current_user_cai')}`;

    return this.http.get(url).pipe(
      catchError(error => {
        return of([]);
      })
    );
  }

  saveAirComplianceDetails(data: any): Observable<any> {

    if (!data) {
      return throwError(() => new Error('Data is required'));
    }

    // Add proper headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    // Format date field properly if needed
    const payload = { ...data };
    payload.tagNumber = this.tagNumber;

    return this.http.post(`${this.apiBaseUrl}Air/SaveOrUpdateAirRecord`, payload, httpOptions).pipe(
      tap(response => {
      }),
      catchError(error => {
        return throwError(() => error);
      })
    );
  }
}

